<template>
  <div class="content">
    <HeaderProductResale
        title="Pagamentos - Histórico"
        text="Registro detalhado de todas as transações financeiras realizadas. Permite acompanhar entradas e saídas de recursos, facilitando a gestão financeira."
        actionTitle=""
        :haveAction="false"
        :haveBack="true"
    >
    </HeaderProductResale>

    <v-dialog v-model="createWithdrawalDialog" max-width="750px">
      <CreateWithdrawal
          @criarSaque="criarSaque"
          @close="createWithdrawalDialog = false"
      >

      </CreateWithdrawal>
    </v-dialog>

    <v-container style="max-width: unset">
      <v-card elevation="0" class="pa-3" >
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" >
            <label>Data de início</label>
            <v-text-field
                v-model="filter.startDate"
                outlined
                dense
                height="41"
                type="date"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" >
            <label>Data de término</label>
            <v-text-field
                v-model="filter.endDate"
                outlined
                dense
                height="41"
                type="date"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" >
            <label>Status</label>
            <v-select
                hide-details
                outlined
                :items="statusList"
                class="secondary-input"
                placeholder="status"
                append-icon="mdi-chevron-down"
                item-text="text"
                item-value="value"
                v-model="filter.status"
                dense
                height="41"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row justify="end">
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6"
                 class="px-2 d-flex justify-space-between"
                 style="margin-top: -20px; "
          >
            <section class="d-flex align-center justify-start">
              <section class="pl-2 d-flex align-center">
                <h2>Saldo: {{
                    (Number(resellerBalance.available_amount) / 100).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </h2>
                <h4> &nbsp;(Total: {{
                    (Number(resellerBalance.available_amount) / 100).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }} - Taxa de transferência {{(4.99).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                  })}})</h4>
              </section>

              <v-btn
                  v-if="resellerBalance.available_amount > 0"
                  outlined
                  height="41"
                  width="140"
                  style="border-radius: 8px!important;"
                  class="ml-3 d-flex justify-center"
                  large
                  @click="createWithdrawalDialog = true"
              >
                <v-icon>mdi-currency-usd</v-icon>
                criar saque
              </v-btn>
            </section>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6"
              class="px-2 d-flex justify-end"
              style="margin-top: -20px; "
          >
            <v-btn
                outlined
                height="41"
                style="border-radius: 8px!important;"
                class="mr-3"
                large
                @click="exportOperations"
            >
              Exportar
            </v-btn>

            <v-btn
                outlined
                height="41"
                style="border-radius: 8px!important;"
                class="mr-3"
                large
                @click="operations()"
            >
              Buscar
            </v-btn>

            <v-btn
                outlined
                style="border-radius: 8px!important;"
                large
                height="41"
                dense
                @click="reset"
            >
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-data-table
          :items="items"
          :loading="loading"
          :headers="headers"
          class="content-table"
          hide-default-footer
          loading-text="Buscando..."
          no-data-text="Sem registros"
      >
        <template v-slot:[`item.created_at`]="{ item }">
          {{formatDate(item.created_at)}}
        </template>

        <template v-slot:[`item.movement_object.object`]="{ item }">
          <span v-if="item.movement_object.object == 'payable'">Recebíveis</span>
          <span v-else-if="item.movement_object.object == 'refund'">Devolução da taxa de boleto</span>
          <span v-else-if="item.movement_object.object == 'transfer'">Transferência</span>
          <span v-else>Descontos relacionados a serviços</span>
        </template>

        <template v-slot:[`item.movement_object.payment_method`]="{ item }">
          <span v-if="item.movement_object.payment_method == 'pix'">Pix</span>
          <span v-else-if="item.movement_object.payment_method == 'credit_card'">Cartão de Crédito</span>
          <span v-else-if="item.movement_object.payment_method == 'boleto'">Boleto</span>
          <span v-else>-</span>
        </template>
        <template v-slot:[`item.movement_object.amount`]="{ item }">
          {{
            (Number(item.movement_object.amount) /100).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </template>
        <template v-slot:[`item.movement_object.installment`]="{ item }">
          {{item.movement_object.installment ? item.movement_object.installment : '-'}}
        </template>
        <template v-slot:[`item.movement_object.fee`]="{ item }">
          {{
            (Number(item.movement_object.fee + (item.movement_object.anticipation_fee ? item.movement_object.anticipation_fee : 0) + (item.movement_object.fraud_coverage_fee ? item.movement_object.fraud_coverage_fee : 0)) /100).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </template>

        <template v-slot:footer class="ma-0 pa-0">
          <section class="ma-0 pa-0">
            <Pagination
                :currentPage="currentPage"
                :totalItems="totalItems"
                :page="page"
                :pageSize="pageSize"
                :totalPages="totalPages"
                @back-page="backPage"
                @next-page="nextPage"
            >
            </Pagination>
          </section>
        </template>
      </v-data-table>
      <v-card elevation="0" class="pa-3" >
        <v-row>
          <v-col>
            <h3><strong>Legenda</strong></h3>
            <div>
              <strong>Taxa de processamento por boleto:</strong> <span>{{
                  (3.49).toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }} </span>
            </div>
            <div>
              <strong>Taxa de processamento por pix: </strong> <span>1.19% </span>
            </div>
            <div>
              <strong>Taxa de processamento por cartão de crédito: </strong> <span>{{
                  (0.99).toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }} </span>
            </div>
            <div>
              <strong>Parcelamento em 1x: </strong> <span> 3.48% </span><br/>
              <strong>Parcelamento em 2x a 5x:  </strong> <span>3.66% </span><br/>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<style scoped>
.content {
  background: #e5e5e5;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import HeaderProductResale from "./components/HeaderProductResale.vue";
import {VMoney} from "v-money";

import Vue from "vue";
import Pagination from "@/views/pages/components/Pagination.vue";
import Utils from "../../../Utils/FormatDate";
import CreateWithdrawal from "./components/CreateWithdrawal.vue";

export default {
  name: "Payments",

  async created() {
    const {resaleId} = this.$route.query
    this.resaleId = resaleId ? resaleId : null;
    const jsonFilters = localStorage.getItem("financial-payments");
    if (jsonFilters) {
      this.filter = JSON.parse(localStorage.getItem("financial-payments"));
      this.page = this.filter.page;
    }
    await this.operations();
    await this.balance();
  },

  data: () => ({
    createWithdrawalDialog: false,
    pageCount: 1,
    pageSize: 10,
    currentPage: 1,
    totalItems: 0,
    totalPages: 0,
    page: 1,
    items: [],
    resellerBalance: {
      available_amount: 0,
      transferred_amount: 0,
      waiting_funds_amount: 0,
    },
    statusList: [
      {
        value: 'waiting_funds',
        text: 'Reserva fincanceira',
      },
      {
        value: 'available',
        text: 'Disponível pra saque',
      },
      {
        value: 'transferred',
        text: 'transferido',
      }
    ],
    loading: false,
    headers: [
      {
        text: "Id do pedido",
        class: "item",
        sortable: false,
        align: "center",
        value: "id",
      },
      {
        text: "Criado em",
        class: "item",
        sortable: false,
        align: "center",
        value: "created_at",
      },
      {
        text: "Tipo de operação",
        class: "item",
        sortable: false,
        align: "center",
        value: "movement_object.object",
      },
      {
        text: "Método de pagamento",
        class: "item",
        sortable: false,
        align: "center",
        value: "movement_object.payment_method",
      },
      {
        text: "Parcela",
        class: "item",
        sortable: false,
        align: "center",
        value: "movement_object.installment",
      },
      {
        text: "Valor",
        class: "item",
        sortable: false,
        align: "center",
        value: "movement_object.amount",
      },

      {
        text: "Taxa",
        class: "item",
        sortable: false,
        align: "center",
        value: "movement_object.fee",
      }
    ],
    apiService: new ApiService(),
    filter: {
      page: 1,
      size: 10,
      startDate: null,
      endDate: null,
      status: null,
    },
    createWithdrawal: {
      resaleId: null,
      amount: null,
    }
  }),

  components: {
    CreateWithdrawal,
    Pagination,
    HeaderProductResale,
  },

  directives: {money: VMoney},

  methods: {
    async balance() {
      await this.apiService
          .get(`resale/balance?resaleId=` + this.filter.resaleId)
          .then((balance) => {
            const {content} = balance;
            if (content) {
              this.resellerBalance = content;
            }
          });
    },
    formatDate(date) {
      return Utils.moment(date);
    },
    reset(){
      this.filter = {
        page: 1,
        size: 10,
        startDate: null,
        endDate: null,
        status: null,
      }
      this.operations()
    },
    async operations() {
      this.filter.resaleId = JSON.parse(localStorage.getItem("user")).id;
      await this.apiService
          .post(`resale/operations`, this.filter)
          .then((operations) => {
            const {content} = operations;
            const {data, paging} = content
            const {total} = paging
            this.items = data;
            this.currentPage = this.filter.page;
          });
    },
    async exportOperations() {
      const body = {
        page: 1,
        size: 10,
        startDate: null,
        endDate: null,
        status: null,
        resaleId: JSON.parse(localStorage.getItem("user")).id
      }
      await this.apiService
          .post(`resale/operations/export`, body)
          .then((response) => {
            const excel = `data:application/octet-stream;base64,${response.content}`;
            const link = document.createElement("a");
            link.href = excel;
            link.setAttribute("download", `pagamentos.xlsx`);
            document.body.appendChild(link);
            link.click();
            this.loading = false;
          });
    },
    async criarSaque(amount) {
      this.createWithdrawal.resaleId = JSON.parse(localStorage.getItem("user")).id;
      this.createWithdrawal.amount = amount;
      this.createWithdrawalDialog = false
      await this.apiService
          .post(`resale/criar-saque`, this.createWithdrawal)
          .then((operations) => {
             console.log(operations);
          });
    },
    async backPage() {
      this.filter.page -= 1;
      await this.operations()
    },

    async nextPage() {
      this.filter.page += 1;
      await this.operations()
    },
  },

  watch: {},
};
</script>
